export default __webpack_public_path__ + "static/media/spark_51.e5fb0fcd.png";